import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=6b979002&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"
import style0 from "./_features.css?vue&type=style&index=0&id=6b979002&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b979002",
  null
  
)

export default component.exports